import { render, staticRenderFns } from "./LicenseForm.vue?vue&type=template&id=40f42d9e&scoped=true&"
import script from "./LicenseForm.vue?vue&type=script&lang=js&"
export * from "./LicenseForm.vue?vue&type=script&lang=js&"
import style0 from "./LicenseForm.vue?vue&type=style&index=0&id=40f42d9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f42d9e",
  null
  
)

export default component.exports